module.exports = __webpack_public_path__ + "img/Comic02-4.3d309d0f.png";